import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

export const ERROR_SHOWN_VALUES = {
  NETWORK: "network",
  PAYMENT: "payment",
  MDI: "mdi",
  SERVER: "server",
  UNKNOWN: "unknown",
} as const;
export type ErrorShownValue =
  (typeof ERROR_SHOWN_VALUES)[keyof typeof ERROR_SHOWN_VALUES];

export const errorShown = defineEvent({
  eventName: "error_shown",
  eventVersion: 1,
  valueSchema: z
    .enum([
      ERROR_SHOWN_VALUES.NETWORK,
      ERROR_SHOWN_VALUES.PAYMENT,
      ERROR_SHOWN_VALUES.MDI,
      ERROR_SHOWN_VALUES.SERVER,
      ERROR_SHOWN_VALUES.UNKNOWN,
    ])
    .or(z.string())
    .optional(),
  metadataSchema: baseEnvelopeSchema
    .extend({
      error_code: z.string().optional(),
      error_message_redacted: z.string().optional(),
      journey_id: z.string().optional(),
    })
    .passthrough(),
});
